// useOtvorZOdkazu — odkaz „<cesta>?open=<id>“ otvorí PRÁVE TEN záznam (CP_OTVOR_V1, ústava 53.3a).
// Mirko 22. 10. 2026: „vytvoril som CP z obhliadky a preplo ma na CP o tri ponuky nižšie“ — Obhliadky skočili
// na /cenove bez čísla a zoznam obnovil z pamäte pozície (53.3) naposledy vybranú CP.
// Pravidlo: kto vytvorí alebo otvorí záznam v inom module, pošle odkaz s jeho id (odkazNaZaznam). Odkaz má
// prednosť pred pamäťou pozície. Hook počká na načítaný zoznam, nájde záznam (id, prípadne iná zhoda — číslo
// dokladu), keď ho skrýva filter alebo hľadanie z pamäte, zruší ich, vyberie ho, posunie zoznam na riadok
// a odkaz z adresy zmaže, aby pri ďalšom obnovení nevyhral nad tým, čo si človek medzitým vybral.
//
//   useOtvorZOdkazu({ rows, loading, najdi, viditelny, vyber, zrusFilter })
//     najdi(odkaz) → riadok | null      (predvolene podľa id)
//     viditelny(riadok) → bool          (je v zozname po filtri a hľadaní?)
//     vyber(id)                         (nastaví vybraný riadok)
//     zrusFilter(riadok)                (filter „všetko“, hľadanie prázdne, záložka riadku)
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const odkazNaZaznam = (cesta, id) => cesta + '?open=' + encodeURIComponent(String(id))
export const odkazZAdresy = (search) => { try { return new URLSearchParams(search == null ? window.location.search : search).get('open') || null } catch (_) { return null } }
// stará verzia dokladu (replaced_by, 67.14) → najnovšia, ktorú zoznam ukazuje
export const najnovsiaVerzia = (rows, row) => { let r = row; for (let i = 0; r && r.replaced_by && i < 20; i++) { const n = rows.find(x => x.id === r.replaced_by); if (!n) break; r = n } return r }

export default function useOtvorZOdkazu({ rows, loading, najdi, viditelny, vyber, zrusFilter, dataAttr = 'data-row-id' }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [cakam, setCakam] = useState(() => odkazZAdresy(location.search))
  const minul = useRef(0)
  // nový odkaz aj vtedy, keď modul už je otvorený (trasa sa nemení, mení sa len ?open=)
  useEffect(() => { const o = odkazZAdresy(location.search); if (o) { minul.current = 0; setCakam(o) } }, [location.search])

  useEffect(() => {
    if (!cakam || loading) return
    const s = String(cakam)
    const row = najdi ? najdi(s) : (rows || []).find(r => String(r.id) === s)
    // záznam ešte nie je v zozname (súbežné obnovenie prišlo s dátami spred vytvorenia) — vybraný je ten z odkazu
    // a hook počká na jedno ďalšie načítanie zoznamu; až potom sa vzdá
    if (!row && minul.current++ < 1) { vyber(s); return }
    setCakam(null)
    const p = new URLSearchParams(location.search)
    if (p.has('open')) { p.delete('open'); const q = p.toString(); navigate({ pathname: location.pathname, search: q ? '?' + q : '' }, { replace: true }) }
    if (!row) return
    if (viditelny && zrusFilter && !viditelny(row)) zrusFilter(row)
    vyber(row.id)
    // posun na riadok: pamäť pozície (53.3) po ďalšom načítaní zoznamu obnoví starý posun, preto sa do 1,2 s
    // ešte niekoľkokrát pozrie, či je riadok v okne zoznamu, a ak nie, posunie znova
    const ukaz = () => {
      const el = document.querySelector('[' + dataAttr + '="' + String(row.id).replace(/"/g, '\\"') + '"]')
      if (!el || !el.scrollIntoView) return
      let p = el.parentElement
      while (p && !(p.scrollHeight > p.clientHeight + 4 && /auto|scroll/.test(getComputedStyle(p).overflowY))) p = p.parentElement
      const r = el.getBoundingClientRect(), o = p ? p.getBoundingClientRect() : { top: 0, bottom: window.innerHeight }
      if (r.top < o.top || r.bottom > o.bottom) el.scrollIntoView({ block: 'center' })
    }
    ;[0, 100, 300, 700, 1200].forEach(ms => setTimeout(() => requestAnimationFrame(ukaz), ms))
  }, [cakam, loading, rows])  // eslint-disable-line react-hooks/exhaustive-deps
}
